import { EditButton as RaEditButton } from "react-admin";
import React from "react";
import VisibilityIcon from "@material-ui/icons/Visibility";
import { useResourcePermissions } from "../../usePermissions";
import { withTranslate } from "react-admin";

const EditButton = ({ label, icon, translate, ...props }) => {
  const { edit } = useResourcePermissions(props);

  // Questa funzione gestisce l'apertura in una pagina esterna quando si clicca sul pulsante di Modifica.
  const handleClick = (e) => {
    const BackResource = props.resource;
    const id = props.record.id.toString();
    let resource = props.resource;

    // Se la risorsa è un dispositivo, ma il basePath è /sensor, allora la risorsa è un sensore.
    // Questa situazione si verifica quando si modifica un sensore da un dispositivo.
    if (
      props.resource === "device" &&
      (props.basePath === "/sensor" || props.basePath === "sensor")
    ) {
      resource = "sensor";
    }

    // Nel caso in cui si sta accedendo al dettaglio di un sensore setto il LocalStorage
    // sensor_origin per poter far funzionare correttamente il tasto indietro.
    if (resource === "sensor" || resource === "device") {
      // Se il BackResource è device e la risorsa è sensor, significa che sto andando
      // nel detatglio del sensore da un dispositivo. Quindi l'indietro lo facciamo andare alla lista dei sensori
      if (BackResource === "device" && resource === "sensor") {
        localStorage.setItem(
          "sensor_origin",
          '#/sensor?filter={"searchKeyword":"","expanded":[],"checked":{},"devices":[],"sensors":[],"locations":[]}'
        );
      } else {
        const localStorageOrigin = `${resource}_origin`;
        const fullHash = window.location.hash;

        localStorage.setItem(localStorageOrigin, fullHash);
      }
    }

    // Se la modalità a schede multiple è disattivata non viene eseguito
    const ModeOpenTabsOn = localStorage.getItem("ModeOpenTabsOn");
    if (ModeOpenTabsOn === "false") {
      return;
    }

    e.preventDefault();

    let raw = localStorage.getItem("openEditTabs");
    let openTabs;
    const url = `${window.location.origin}${window.location.pathname}#${props.basePath}/${id}`;

    try {
      openTabs = raw ? JSON.parse(raw) : {};
    } catch {
      openTabs = {};
    }

    // Inizializza lista se mancante
    if (!Array.isArray(openTabs[resource])) {
      openTabs[resource] = [];
    }

    // Modifica per bloccare l'apertura di un tab se già aperto - start

    const openSet = new Set(openTabs[resource]);

    // Se l'ID è già presente -> mostra messaggio e blocca apertura
    if (openSet.has(id)) {
      alert(
        translate("resource.open.tabs.message.block", {
          resource: resource,
          id: id,
        })
      );

      return;
    }

    // Modifica per bloccare l'apertura di un tab se già aperto - end

    if (typeof openTabs !== "object" || Array.isArray(openTabs)) {
      openTabs = {};
    }

    if (!openTabs[resource]) openTabs[resource] = [];
    if (!openTabs[resource].includes(id)) openTabs[resource].push(id);

    localStorage.setItem("openEditTabs", JSON.stringify(openTabs));

    // Manda messaggio agli altri tab
    const bc = new BroadcastChannel("editTabs");
    bc.postMessage(openTabs);
    bc.close();

    // Apri tab di modifica
    window.open(url, "_blank", "noopener,noreferrer");
  };
  return (
    <RaEditButton
      {...props}
      icon={edit ? icon : <VisibilityIcon />}
      label={edit ? label : "ra.action.show"}
      onClick={handleClick}
    />
  );
};

export default withTranslate(EditButton);
